import useGlobalConfig from '@/store/global';

const Wilate = () => {
  const { themeColor } = useGlobalConfig();
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <div
          className="my-6 border-b-2 border-sky-700 border-dotted"
          style={{ borderColor: themeColor }}
        />

        <div className="font-bold">
          Indications and Important Safety Information for wilate® [von Willebrand
          Factor/Coagulation Factor VIII Complex (Human)].
        </div>

        <p className="mt-2 font-bold">
          Please see&nbsp;
          <a
            target="_blank"
            href="/wilate-full-prescribing-information.pdf"
            className="underline"
            rel="noopener noreferrer"
          >
            wilate Full Prescribing Information
          </a>
          .
        </p>

        <div className="mt-6">
          <p className="my-2 font-bold">Indications</p>
          <p className="my-2">
            wilate® is a von Willebrand Factor/Coagulation Factor VIII Complex (Human) indicated in
            children and adults with von Willebrand disease for on-demand treatment and control of
            bleeding episodes; for perioperative management of bleeding; and for routine prophylaxis
            to reduce the frequency of bleeding episodes in children 6 years of age and older and
            adults with VWD. wilate® is also indicated in adolescents and adults with hemophilia A
            for routine prophylaxis to reduce the frequency of bleeding episodes; and for on-demand
            treatment and control of bleeding episodes.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Contraindications</p>
          <p className="my-2">
            wilate® is contraindicated in patients with known hypersensitivity reactions, including
            anaphylactic or severe systemic reactions, to human plasma-derived products, any
            ingredient in the formulation, or components of the container.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Warnings and Precautions</p>

          <p className="my-2 font-semibold">Hypersensitivity Reactions</p>
          <p className="my-2">
            Hypersensitivity reactions may occur with wilate®. Signs and symptoms include
            angioedema, burning and stinging at the infusion site, chills, flushing, generalized
            urticaria, headache, hives, hypotension, lethargy, nausea, restlessness, tachycardia,
            tightness of the chest, tingling, vomiting, and wheezing that may progress to severe
            anaphylaxis (including shock) with or without fever. Closely monitor patients receiving
            wilate® and observe for any symptoms throughout the infusion period.
          </p>
          <p className="my-2">
            Because inhibitor antibodies may occur concomitantly with anaphylactic reactions,
            evaluate patients experiencing an anaphylactic reaction for the presence of inhibitors.
          </p>

          <p className="mt-6 font-semibold">Thromboembolic Events</p>
          <p className="my-2">
            In VWD, continued treatment using a FVIII-containing VWF product may cause an excessive
            rise in FVIII activity, which may increase the risk of thromboembolic events. Monitor
            plasma levels of VWF:RCo and FVIII activities in patients receiving wilate to avoid
            sustained excessive VWF and FVIII activity levels.
          </p>

          <p className="mt-6 font-semibold">Neutralizing Antibodies</p>
          <p className="my-2 font-semibold">VWD</p>
          <ul className="list-disc ml-4">
            <li className="my-2">
              Neutralizing antibodies (inhibitors) to FVIII and VWF in patients with VWD, especially
              type 3 patients, may occur. If a patient develops inhibitor to VWF (or to FVIII), the
              condition will manifest itself as an inadequate clinical response. Thus, if expected
              VWF activity plasma levels are not attained, or if bleeding is not controlled with an
              adequate dose or repeated dosing, perform an appropriate assay to determine whether a
              VWF inhibitor is present.
            </li>
            <li className="my-2">
              In patients with antibodies against VWF, VWF is not effective and wilate
              administration may lead to severe adverse events. Consider other therapeutic options
              for such patients.
            </li>
            <li className="my-2">
              Because inhibitor antibodies may occur concomitantly with anaphylactic reactions,
              evaluate patients experiencing an anaphylactic reaction for the presence of
              inhibitors.
            </li>
          </ul>

          <p className="my-2 font-semibold">Hemophilia A</p>
          <ul className="list-disc ml-4">
            <li className="my-2">
              Monitor plasma Factor VIII activity by performing a validated test (e.g., one stage
              clotting assay), to confirm that adequate Factor VIII levels have been achieved and
              maintained.
            </li>
            <li className="my-2">
              Monitor for the development of Factor VIII inhibitors. Perform a Bethesda inhibitor
              assay if expected Factor VIII plasma levels are not attained, or if bleeding is not
              controlled with the expected dose of Wilate. Use Bethesda Units (BU) to report
              inhibitor levels.
            </li>
          </ul>

          <p className="mt-6 font-semibold">Transmissible Infectious Agents</p>
          <p className="my-2">
            wilate® is made from human plasma. Because this product is made from human blood, it
            may carry a risk of transmitting infectious agents, e.g., viruses, and theoretically,
            the variant Creutzfeldt-Jakob disease (vCJD) agent. There is also the possibility that
            unknown infectious agents may be present in the product. The risk that wilate® will
            transmit viruses has been reduced by screening plasma donors for prior exposure to
            certain viruses, by testing for the presence of certain current virus infections, and by
            inactivating and removing certain viruses during manufacture. Despite these measures, it
            may still potentially transmit disease.
          </p>
          <p className="my-2">
            Record the batch number of the product every time wilate® is administered to a patient
            and consider appropriate vaccination (against hepatitis A and B virus) of patients in
            regular/repeated receipt of wilate®. ALL infections thought by a physician possibly to
            have been transmitted by this product should be reported by the physician or other
            healthcare provider to Octapharma USA, Inc., at 1-866-766-4860.
          </p>

          <p className="mt-6 font-semibold">Monitoring and Laboratory Tests</p>
          <ul className="list-disc ml-4">
            <li className="my-2">
              Monitor plasma levels of VWF:RCo and FVIII activities in patients receiving wilate®
              to avoid sustained excessive VWF and FVIII activity levels, which may increase the
              risk of thromboembolism, particularly in patients with known clinical or laboratory
              risk factors.
            </li>
            <li className="my-2">
              Monitor for development of VWF and FVIII inhibitors. Perform assays to determine
              whether VWF and/or FVIII inhibitor(s) is present if bleeding is not controlled with
              the expected dose of wilate®.
            </li>
          </ul>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Adverse Reactions</p>
          <p className="my-2">
            The most common adverse reactions to treatment with wilate (≥ 1%) in patients with VWD
            were hypersensitivity reactions, urticaria, and dizziness. The most common adverse
            reactions to treatment with wilate (≥ 1%) in previously treated patients with hemophilia
            A was pyrexia (fever).
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2">
            Please&nbsp;
            <a
              target="_blank"
              href="/wilate-full-prescribing-information.pdf"
              className="!text-sky-700 hover:underline"
              rel="noopener noreferrer"
            >
              click here
            </a>
            &nbsp;for Full Prescribing Information.
          </p>
        </div>
      </div>
    </>
  );
};

export default Wilate;
